import { render, staticRenderFns } from "./RegistrationApprovalPanel.vue?vue&type=template&id=8d89fe2c&scoped=true"
import script from "./RegistrationApprovalPanel.vue?vue&type=script&lang=js"
export * from "./RegistrationApprovalPanel.vue?vue&type=script&lang=js"
import style0 from "./RegistrationApprovalPanel.vue?vue&type=style&index=0&id=8d89fe2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d89fe2c",
  null
  
)

export default component.exports